import React, { useState, useEffect } from "react";
import "./admindashboard.css";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import {
  // Warning,
  // DateRange,
  // LocalOffer,
  // Update,
  // ArrowUpward,
  // Accessibility,
  // BugReport,
  // Code,
  AssignmentTurnedIn,
  Announcement,
  // CheckBoxOutlineBlankRounded,
  AccessTime,
  Group,
  Person,
  LiveHelp,
  // ShowChart,
} from "@material-ui/icons/";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Table from "components/Table/Table.js";
// import Tasks from "components/Tasks/Tasks.js";
// import CustomTabs from "components/CustomTabs/CustomTabs.js";
// import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
// import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
// import { bugs, website, server } from "variables/general.js";

import // dailySalesChart,
// emailsSubscriptionChart,
// completedTasksChart,
"variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/AdmindashboardStyle.js";
// import { Icon } from "@material-ui/core";
// import AssocService from "../../services/assoc.service";
import DashboardService from "../../services/dashboard.service";
import academyService from "../../services/academy.service";
import authService from "../../services/auth.service";
//Import Loading
import Spinner from "react-bootstrap/Spinner";

const useStyles = makeStyles(styles);

export default function AssocDashboard() {
  const [loading, setLoading] = useState(true);
  // const [loadingAlert, setLoadingAlert] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  // const [chartdata, setChartdata] = useState([]);
  const [assocNameThai, setAssocNameThai] = useState("");

  const user = authService.getCurrentUser();

  useEffect(() => {
    getData(user.user.user_assoc);
    getAssocName(user.user.user_assoc);
    // getData(49);
    // getAssocName(49);
  }, []);

  const getAssocName = (id) => {
    academyService.getAcademyById(id).then((response) => {
      setAssocNameThai(response.data.data.association_name_th);
    });
  };
  // console.log(user.user.user_assoc);
  // useState(() => {
  //   getData(user.user.user_assoc);
  // }, []);

  const getData = (academy_id) => {
    DashboardService.getSumByAssociationId(academy_id)
      .then((response) => {
        setData(response.data.data[0]);
        // setChartdata(data);
        // console.log(response.data.data[0]);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  let pie_farmerStatus = {
    labels: [
      data.no3yr > 0
        ? "ขาดส่ง (" + parseInt(data.no3yr).toLocaleString("en") + ")"
        : "-",
      data.goodid > 0
        ? "ปกติ (" + parseInt(data.goodid).toLocaleString("en") + ")"
        : "-",
      data.dead > 0
        ? "รอตรวจสอบ (" + parseInt(data.dead).toLocaleString("en") + ")"
        : "-",
      // "ระบุไม่ได้\r\n(" + parseInt(data.no_status).toLocaleString("en") + ")",
    ],
    series: [
      {
        name: "no3yr",
        value: data.no3yr > 0 ? data.no3yr : "-",
        className: "ct-series-c",
      },
      {
        name: "goodid",
        value: data.goodid > 0 ? data.goodid : "-",
        className: "ct-series-a",
      },
      {
        name: "badid",
        value: data.badid > 0 ? data.badid : "-",
        className: "ct-series-b",
      },
      // {
      //   name: "no_status",
      //   label: parseInt(data.suspended).toLocaleString("en"),
      //   value: data.no_status,
      //   ignoreEmptyValues: true,
      //   className: "ct-series-f",
      // },
    ],
  };

  let pie_approveStatus = {
    labels: [
      data.approved > 0
        ? "อนุมัติ\r\n(" + parseInt(data.approved).toLocaleString("en") + ")"
        : "-",
      data.suspended > 0
        ? "รออนุมัติ\r\n(" + parseInt(data.suspended).toLocaleString("en") + ")"
        : "-",
      // "ไม่มีข้อมูล (" + parseInt(data.no_status).toLocaleString("en") + ")",
    ],
    series: [
      {
        name: "approved",
        // label: data.approved > 0 ? parseInt(data.approved).toLocaleString("en") : "-",
        value: data.approved > 0 ? data.approved : "-",
        className: "ct-series-e",
      },
      // {
      //   name: "suspended",
      //   label: parseInt(data.suspended).toLocaleString("en"),
      //   value: data.suspended,
      //   ignoreEmptyValues: true,
      //   className: "ct-series-c",
      // },
      {
        name: "no_status",
        value: data.no_status > 0 ? data.no_status : "-",
        className: "ct-series-f",
      },
    ],
  };

  let pie_approveDopa = {
    labels: [
      data.alive > 0
        ? "มีชีวิต (" + parseInt(data.alive).toLocaleString("en") + ")"
        : "-",
      data.dead > 0
        ? "เสียชีวิต (" + parseInt(data.dead).toLocaleString("en") + ")"
        : "-",
    ],
    series: [
      {
        name: "alive",
        value: data.alive > 0 ? data.alive : "-",
        className: "ct-series-d",
      },
      {
        name: "dead",
        value: data.dead > 0 ? data.dead : "-",
        className: "ct-series-f",
      },
    ],
  };

  let pie_options = {
    startAngle: 0,
    donut: false,
    width: "400px",
    height: "400px",
    total: data.members > 0 ? data.members : "-",
    showLabel: true,
    labelPosition: "inside",
    labelDirection: "neutral", // neutral, explode
    labelOffset: 80,
    chartPadding: 80,
    style: { wordwrap: "break-word" },
    // labelInterpolationFnc: function (value) {
    //   return Math.round((value / data.series.reduce(sum)) * 100) + "%";
    // },
    // responsiveOptions,
  };

  const classes = useStyles();
  // console.log("adminDashboard");
  if (loading) return <Spinner animation="border" variant="primary" />;
  if (error) return `Error :${error}`;

  return (
    <div>
      <h3 className="text-center">{assocNameThai}</h3>
      <GridContainer>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Group />
              </CardIcon>
              <p className={classes.cardCategory}>สมาชิก</p>
              <h3 className={classes.cardTitle}>
                {parseInt(data.members).toLocaleString("en")}
                &nbsp;<small> คน</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {/* <DateRange />
                Last 24 Hours */}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                {/* <Icon>{Person}</Icon> */}
                <Person />
              </CardIcon>
              <p className={classes.cardCategory}>หัวหน้ากลุ่ม</p>
              <h3 className={classes.cardTitle}>
                {parseInt(data.grouphead).toLocaleString("en")}
                &nbsp;<small> ราย</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}></div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                {/* <Accessibility /> */}
                <AssignmentTurnedIn />
              </CardIcon>
              <p className={classes.cardCategory}>อนุมัติ</p>
              <h3 className={classes.cardTitle}>
                {parseInt(data.approved).toLocaleString("en")}
                &nbsp;<small>ราย</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}></div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Person />
              </CardIcon>
              <p className={classes.cardCategory}>ยืนยันสถานะ</p>
              <h3 className={classes.cardTitle}>
                {parseInt(data.goodid).toLocaleString("en")}
                &nbsp;<small> คน</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {/* <DateRange />
                Last 24 Hours */}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <LiveHelp />
              </CardIcon>
              <p className={classes.cardCategory}>ไม่ยืนยันสถานะ</p>
              <h3 className={classes.cardTitle}>
                {parseInt(data.badid).toLocaleString("en")}
                &nbsp;<small> ราย</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}></div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                {/* <Accessibility /> */}
                <AccessTime />
              </CardIcon>
              <p className={classes.cardCategory}>ขาดส่ง</p>
              <h3 className={classes.cardTitle}>
                {parseInt(data.no3yr).toLocaleString("en")}
                &nbsp;<small>ราย</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {/* <Update />
                Just Updated */}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                {/* <Icon>info_outline</Icon> */}
                <Announcement />
              </CardIcon>
              <p className={classes.cardCategory}>ไม่ระบุสถานะ</p>
              <h3 className={classes.cardTitle}>
                {parseInt(data.no_status).toLocaleString("en")}
                &nbsp;<small>ราย</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {/* <LocalOffer />
                Tracked from Github */}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={4} align="center">
          <ChartistGraph
            data={pie_farmerStatus}
            options={pie_options}
            type="Pie"
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={4} align="center">
          <ChartistGraph
            data={pie_approveStatus}
            options={pie_options}
            type="Pie"
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={4} align="center">
          <ChartistGraph
            data={pie_approveDopa}
            options={pie_options}
            type="Pie"
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
